import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UseGameSvcLstQuery from 'Apis/GameSvcLstInqApi';
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import { useQueryClient } from 'react-query';
import { Helmet } from 'react-helmet-async';
import EntreGameLstUi from './EntreGameLstUi';
import MainPageRcmnGameUi from './MainPageRcmnGameUi';
import CtntTop5LstUi from './CtntTop5LstUi';
import MainEventBnrUi from './EventBnrSlide';
import "Assets/css/mainPage.css";


const MainPage = () => {
        const navigate = useNavigate();
        useEffect(() => {
                navigate('/Landing?gameSvcCd=BBO', { replace: true });
            
        }, [navigate]);
    // 기존 MainPage UI 렌더링 코드 (리다이렉트 비활성화 시 사용)
    /*
    const {isLoading,error,data}:any = UseGameSvcLstQuery();
    const {data: langData}:any = UseLangLstQuery();
    return(
        <>
            <Helmet>
                <title>MGP</title>
            </Helmet>
            <MainEventBnrUi></MainEventBnrUi>
            <div className='ctntLstContainer container1400'>
                <CtntTop5LstUi gameSvcCd='MGP' ctntCtgrCd="PNOT" ctntCtgrCdName={langData&&langData.MAIN_PAGE_PNOT_LST_TITL_00}LstType={"top5"}></CtntTop5LstUi>
                <CtntTop5LstUi gameSvcCd='MGP' ctntCtgrCd="UPDT" ctntCtgrCdName={langData&&langData.MAIN_PAGE_UPDT_LST_TITL_00}LstType={"top5"}></CtntTop5LstUi>
            </div>
            <MainPageRcmnGameUi rcmnGameTitl={langData&&langData.MAIN_PAGE_RCMN_GAME_TITL_00} rcmnGameData={data}></MainPageRcmnGameUi>
            <EntreGameLstUi gameSvcLstData={data}></EntreGameLstUi>
        </>
    )
    */
    // 리다이렉트 활성화
    return null;
}

export default MainPage;